import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { PaymentLinkLandingComponentPermissionActions } from '../actions';
import { selectGetSessionFromPaymentLinkResponse } from '../../../../store/reducers';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { concatLatestFrom } from '@ngrx/operators';

@Injectable()
export class PaymentLinkLandingComponentPermissionEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private router: Router,
  ) {}

  navigateToSessionLogin$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          PaymentLinkLandingComponentPermissionActions.verifyUserIsProvisionedSuccess,
        ),
        concatLatestFrom(() => [
          this.store.select(selectGetSessionFromPaymentLinkResponse),
        ]),
        exhaustMap(([, session]) => {
          const isPayOnAccount = session.sessionType === 'PayOnAccount';
          const baseUrl = isPayOnAccount
            ? `/paymentlinks/${session.tenantId}/${session.paymentSessionToken}/payonaccount`
            : `/paymentlinks/${session.tenantId}/${session.paymentSessionToken}`;

          const sessionUrl = session.isInternationalPayment
            ? `${baseUrl}/intl`
            : baseUrl;

          this.router.navigateByUrl(
            `/paymentlinklogin?token=${session.accessToken}&tenantId=${session.tenantId}&returnUrl=${sessionUrl}`,
          );
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );

  navigateOnVerifyUserError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          PaymentLinkLandingComponentPermissionActions.verifyUserIsProvisionedError,
        ),
        exhaustMap(() => {
          this.router.navigate(['/paymentlinks/error']);
          return EMPTY;
        }),
      ),
    { dispatch: false },
  );
}
